<template>
    <article class="dealer-locator__result-container">
        <div @click="openDealer" class="dealer-locator__result" :class="{ 'dealer-locator__result-closed': dealer.closed }">
            <FakeCard v-if="dealer.fake" link="/used-vehicles/results?sortBy=saleEvent"/>
            <template v-else>
                <!-- <a :href="`/${dealerUrl}` "class="dealer-locator__result-image-container"> -->
                    <ThumbnailPicture :dealer="dealer"/>
                <!-- </a> -->
                <div class="dealer-locator__result--details">
                    <h3 class="dealer-locator__result--title" v-html="dealer.name" />

                    <template v-if="!dealer.closed">
                        <Rating :dealer="dealer" />

                        <div
                            v-if="!dealer.coming_soon"
                            class="dealer-locator__result--phone"
                        >
                            <MediaHawkNumber
                                v-if="dealer.mediahawk_number"

                                class="btn btn--primary--lighten"
                                :display-number="`Call us on: ${dealer.tel_general}`"
                                :telNumber="dealer.tel_general"
                            />
                            <a
                                v-else
                                class="btn btn--primary--lighten"
                                :href="`tel:${dealer.tel_general}`"

                                @click="customEvent('Dealer Locator', 'Phone number', 'Clicked')"
                            >
                                Call us on: {{dealer.tel_general}}
                            </a>
                        </div>
                        <div
                            class="dealer-locator__result--details-section"
                        >
                            <div class="dealer-locator__result--address-container">
                                <MapPin/>
                                <div class="dealer-locator__result--address-container--address">
                                    {{ dealer.address }}<br />
                                    {{ dealer.town }}, {{ dealer.postcode }}<br />
                                </div>
                            </div>

                            <div v-if="dealer.what3words" class="dealer-locator__result--what3words">
                                <template>
                                    <img class="dealer-locator__result--what3words-graphic" src="/images/what3words.svg" alt="What3words">
                                    <a
                                        class="dealer-locator__result--what3words-link"
                                        :href="`https://w3w.co/${dealer.what3words}`"
                                        target="_blank"

                                        @click="customEvent('Dealer Locator', 'What 3 words', 'Clicked')"
                                    >
                                        {{ dealer.what3words }}
                                    </a>
                                </template>
                            </div>

                            <div v-if="distance" class="dealer-locator__result--distance">
                                Distance: {{ distance }} miles away
                            </div>

                            <OpeningHours
                                v-if="!dealer.coming_soon"
                                :dealer="dealer"
                            />
                        </div>
                    </template>

                    <p v-else>This dealership has now closed</p>

                    <span v-if="dealer.special_announcement" class="dealer-locator__result-extra-message">{{ dealer.announcements }}</span>
                </div>

                <div v-if="!dealer.closed" class="dealer-locator__result--actions">
                    <Services
                        v-if="!dealer.coming_soon"
                        :dealer="dealer"
                    />

                    <a
                        :href="dealerUrl"
                        class="btn btn--primary"
                        @click="customEvent('Dealer Locator', 'View details button', 'Clicked')"
                    >
                        Discover more
                    </a>
                </div>
            </template>
        </div>
    </article>
</template>

<script>
    import { defineComponent } from "vue";
    import ThumbnailPicture from "./ThumbnailPicture.vue";
    import MediaHawkNumber from "./MediaHawkNumber.vue";
    import Services from "./Services.vue";
    import Rating from "./Rating.vue";
    import OpeningHours from "./OpeningHours.vue";
    import FakeCard from "../../../used-vue/components/Campaign/2026/April/FakeCard.vue";
    import MapPin from "./MapPin.vue";
    import { customEvent } from "../../../modules/tracking/AnalyticsEvents";
    import { calculateDistance } from '../../../used-vue/api/LocationFunctions'
    import { mapState } from "vuex";

    export default defineComponent({
        name: 'Result',

        components: {
            ThumbnailPicture,
            MediaHawkNumber,
            Services,
            Rating,
            OpeningHours,
            FakeCard,
            MapPin
        },

        props: {
            dealer: Object
        },

        computed: {
            ...mapState('DealerData', ['filters']),

            dealerUrl() {
                return this.dealer.url || '#';
            },

            distance(){
                if(this.filters.lat && this.filters.lng){
                    return calculateDistance(this.filters.lat, this.filters.lng, this.dealer.lat, this.dealer.lng).toFixed(1)
                }

                return null
            }
        },

        methods: {
            customEvent: customEvent,
            openDealer(event) {
                if (event.target.closest('a, button, .dropdown-options, .dealer-locator__result--opening-hours-container')) {
                    return;
                }

                window.location.href = this.dealerUrl;
            }
        },

        mounted() {
            this.$nextTick(() => {
                this.$emit('match-height');
            });
        }
    })
</script>